/* src/app/job-signoff/pages/job-signoff-edit-manager/job-signoff-edit-manager.component.scss */
/*# sourceMappingURL=job-signoff-edit-manager.component.css.map */
